import { FC, ReactNode } from "react";
import { Typography, TypographyProps } from "@mui/material";
import { TitleContainer } from "../atoms";

interface TitleProps {
  title: string;
  rightSide?: ReactNode;
  variant?: TypographyProps["variant"];
  margin?: string;
}

const Title: FC<TitleProps> = ({
  title,
  rightSide,
  variant = "h2",
  margin = "15px 0",
}) => (
  <TitleContainer>
    <Typography variant={variant} sx={{ margin }}>
      {title}
    </Typography>
    <div>{rightSide}</div>
  </TitleContainer>
);

export { Title };
